<template>
    <div class="tariff">
        <el-dialog title="类目押金" :visible.sync="dialogVisible" width="1024px" :before-close="handleClose">
            <div class="icon-box scroll-auto">
                <div class="item" v-loading="categoryLoad" v-if="CategoryData && CategoryData.length > 0">
                    <div class="icon">
                        <span>
                            <i class="iconfont icon-leimu"></i>
                        </span>
                        <div class="til">
                            <p>类目押金</p>
                            <span>￥{{ all_price }}</span>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(item, index) in CategoryData" :key="index" :class="item.deposit - item.amount > 0 ? 'red' : ''">
                            <p style="color: #606266">
                                <el-checkbox v-if="item.deposit - item.amount > 0 && count > 1" v-model="item.checked" @change="selChange(item)"
                                    >{{ item.top_name }} > {{ item.parent_name }} > {{ item.name }}</el-checkbox
                                >
                                <span v-else>{{ item.top_name }} > {{ item.parent_name }} > {{ item.name }}</span>
                            </p>
                            <span>￥{{ item.amount }}</span>
                            <p class="price" v-if="item.deposit - item.amount > 0">
                                原类目押金￥{{ item.deposit }}<span>应补缴：￥{{ item.pay_amount }}</span>
                            </p>
                        </li>
                    </ul>
                </div>
                <el-empty v-else description="暂无押金不足的类目"></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="box">
                    <p>
                        补缴金额：<span class="red">￥{{ all_price }}</span>
                    </p>
                    <div>
                        <el-button @click="handleClose">取 消</el-button>
                        <el-button type="primary" @click="recharge" v-show="all_price > 0">补缴押金</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            CategoryData: [],
            categoryLoad: false,
            all_price: '',
            opt: ["已提交", "审核通过", "审核失败"],
            shop_id: "",
            ids: [],
            checked: false,
            count: 0,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            storeapplyMoney: "detect/storeapplyMoney",
        }),
        selChange(item) {
            if (item.checked) {
                this.all_price += Number(item.pay_amount);
                this.ids.push(item.ids);
            } else {
                this.all_price -= item.pay_amount;
                this.ids = this.ids.filter((val) => val != item.ids);
            }
        },
        recharge() {

            this.$emit("showPay", this.ids.toString(), this.all_price);
        },
        handleClose() {
            this.dialogVisible = false;
            this.ids = [];
            this.shop_id = "";
            this.all_price = 0;
            this.CategoryData = [];
            this.count = 0;
        },
        getList(id) {
            this.categoryLoad = true;
            let params = {
                token: this.getToken,
                shop_id: id,
                tread_status: 2, //支付状态 1-待支付 2-支付成功 3-支付失败
            };
            this.storeapplyMoney(params).then(({ data }) => {
                this.categoryLoad = false;
                this.CategoryData = data.data.category;
                console.log(data,'66666')
                this.CategoryData.forEach((item, index) => {
                    if (item.deposit - item.amount > 0) {
                        this.$set(item, "checked", false);
                        this.count++;
                        this.all_price += item.pay_amount;
                        this.ids.push(item.ids);
                        if (this.count > 1) {
                            this.ids = [];
                            this.all_price = 0;
                        }
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss">
.tariff {
    .icon-box {
        height: 450px;
        .item {
            margin-bottom: 30px;
            width: 100%;
            padding: 20px;
            background: #ffffff;
            ul {
                margin-top: 20px;
                border-top: 1px solid #ddd;
                li {
                    list-style: none;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 60px;
                    line-height: 60px;
                    border-bottom: 1px solid #ddd;
                    color: #333;
                    .price {
                        color: #666;
                        span {
                            color: #ea5846;
                            margin-left: 20px;
                        }
                    }
                }
            }
            .icon {
                display: flex;
                align-items: center;
                & > span {
                    margin-right: 24px;
                    display: block;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    border: 2px solid #ddd;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    i {
                        font-size: 32px;
                        color: #666;
                    }
                }
                .til {
                    p {
                        font-size: 16px;
                        font-weight: bold;
                        color: #333333;
                        line-height: 36px;
                    }
                    span {
                        color: #ea5846;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
.box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.red {
    & > p {
        color: #ea5846 !important;
    }
    span {
        color: #ea5846 !important;
    }

    & > p.price {
        color: #666 !important;
    }
}
::v-deep .el-checkbox__label {
    color: #ea5846 !important;
}
.el-checkbox {
    color: #ea5846 !important;
}
</style>